const SAJM_GLOBALS = {
    //DISTANT
    API_HOST : "http://api.apotresdejesusetdemarie.fr/api",
    
    //LOCAL
    //API_HOST : "http://localhost:3000/api",

    /*************************/
    /*PLATFORM GIVE WP (dons)*/
    /*************************/

    GIVEWP_KEY : "8e081909daeb39d7af16d5ed415772eb",
    GIVEWP_TOKEN : "0b3bb999329fbcaa65b76a41a5d1c23b",
    GIVEWP_URL : "https://apotresdejesusetdemarie.fr/give-api",

    /*************************/
    /*PLATFORM WORDPRESS     */
    /*************************/

    WP_HOST: "https://apotresdejesusetdemarie.fr",
    WP_USER: "sajm_api",
    WP_PASSWORD: "hruQ*1QkQQqirsmi$dEvUT2p",

    /**
     * Hello Asso Contants
     */

    HA_CLIENTID: "7a5a1497df4b4f4ab4c39e10be3cbf37",
    HA_CLIENTSECRET: "pBgx68Zch15xlRoFvZMSBoxWMA7+G8od",
    HA_API_HOST : "https://api.helloasso.com",
    HA_API_ROUTE_TOKEN : "/oauth2/token",
    HA_API_ROUTE_MY_ORGANIZATIONS : "/v5/users/me/organizations",
    HA_API_ROUTE_ORGANIZATIONS : "/v5/organizations",
    

}


export default SAJM_GLOBALS;